import Dependency from './Dependency';

export default Dependency;
